/** @type {import('../help-index.js').HelpSidebarItem} */
export const FIN_BAN_LOANS_ITEM = {
  id: 'banks_loans',
  screenId: 'fin-ban-loans',
  label: 'Préstamos',
  description: 'Préstamos bancarios: plan de cuotas, desembolso y pagos.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Registrás préstamos tomados con el banco: monto principal, plan de cuotas, desembolso del capital a la cuenta y pagos posteriores imputados a centros de ingreso y gasto.',
      },
      {
        title: 'Paso 1 — Filtrar y leer la lista',
        fields: [
          {
            label: 'Cuenta',
            description: 'Filtrá por una cuenta bancaria o dejá «Todas las cuentas».',
          },
        ],
        bullets: [
          'Columnas: ID, Fecha, Cuenta, Principal (monto y moneda), Cuotas, Desembolsado (Sí/No), Descripción.',
          'Tocá una fila para abrir el detalle del préstamo.',
          'Solo los préstamos aún no desembolsados pueden editarse (botón «Editar préstamo» dentro del detalle).',
        ],
      },
      {
        title: 'Paso 2 — Crear un préstamo',
        intro: 'El botón + abre el formulario completo.',
      },
      {
        title: 'Datos del préstamo',
        fields: [
          { label: 'Cuenta bancaria', description: 'Cuenta donde se acreditará el préstamo. Define también la moneda.' },
          { label: 'Fecha del préstamo', description: 'Fecha de origen del préstamo.' },
          { label: 'Cantidad de cuotas', description: 'Entre 1 y 360. Al cambiarla se regenera la tabla de cuotas (solo en alta).' },
          { label: 'Descripción', description: 'Referencia interna opcional.' },
          { label: 'Monto principal', description: 'Capital del préstamo en la moneda de la cuenta.' },
        ],
      },
      {
        title: 'Centros para flujo de fondos',
        fields: [
          {
            label: 'Cuenta de ingreso (desembolso)',
            description:
              'Centro de ingresos donde se imputa el ingreso del capital cuando desembolsás. Buscá escribiendo al menos 3 letras.',
          },
          {
            label: 'Cuenta de gasto (pago de cuotas)',
            description:
              'Centro de costo (gasto) donde se imputan los pagos de cuotas. También obligatorio.',
          },
        ],
      },
      {
        title: 'Plan de cuotas',
        intro: 'Completá una fila por cuota:',
        fields: [
          { label: 'Vencimiento', description: 'Fecha de vencimiento. Obligatoria en todas las cuotas.' },
          { label: 'Capital', description: 'Parte de amortización del principal.' },
          { label: 'Interés', description: 'Intereses de la cuota.' },
          { label: 'IVA', description: 'IVA sobre intereses u otros conceptos, si aplica.' },
          { label: 'Otros', description: 'Seguros, gastos bancarios u otros cargos.' },
          { label: 'Total', description: 'Suma calculada de la fila (no se edita directamente).' },
        ],
        paragraphs: [
          'Arriba de la tabla ves el capital total en cuotas comparado con el monto principal.',
          'Tocá «Guardar» para crear o actualizar el préstamo.',
        ],
      },
      {
        title: 'Paso 3 — Desembolsar',
        intro: 'Desde el detalle, si el préstamo aún no está desembolsado:',
        fields: [
          { label: 'Fecha del movimiento', description: 'Día en que ingresa el capital a la cuenta.' },
          { label: 'Referencia', description: 'Número de comprobante u observación opcional.' },
        ],
        paragraphs: [
          '«Desembolsar» genera un movimiento de ingreso en la cuenta bancaria y lo imputa al centro de ingreso configurado.',
          'Después del desembolso ya no podés editar los datos generales del préstamo.',
        ],
      },
      {
        title: 'Paso 4 — Pagar cuotas',
        intro: 'Con el préstamo desembolsado, en el mismo detalle podés registrar pagos:',
        fields: [
          { label: 'Cuota', description: 'Elegí una cuota con saldo pendiente.' },
          { label: 'Fecha', description: 'Día del débito en banco.' },
          { label: 'Monto', description: 'Importe a pagar (no puede superar el pendiente de la cuota).' },
          { label: 'Referencia', description: 'Opcional.' },
        ],
        paragraphs: [
          'El pago genera un movimiento en la cuenta y lo imputa al centro de gasto del préstamo.',
          'Podés editar cuotas pendientes (vencimiento e importes) desde el editor de cuotas en el detalle, respetando lo ya pagado.',
        ],
      },
    ],
  },
}
